export { NavigationTabs } from './NavigationTabs';
